module.exports = __webpack_public_path__ + "assets/img/4-3.b389a3d5.png";